import React, { useEffect, useState, useContext } from "react";
import Row from "../Row";
import Column from "../Column";
import jobContext from "src/context/jobContext";
import { useLocation } from "react-router-dom";


const Table7 = ({ forms, setForms, reload }) => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const jobId = params.get("id");
  const { setGreadingScore } = useContext(jobContext)

  const [data, setData] = useState([])
  useEffect(() => {
    const items = JSON.parse(localStorage?.data)?.[jobId]?.forms;
    if (items) {
      const masouliat = items[Object.keys(items)[0]];
      const masouliatData = [
        { name: "سطح یک", score: 6, isSelected: masouliat.value == 0 },
        { name: "سطح دو", score: 12, isSelected: masouliat.value == 1 },
        { name: "سطح سه", score: 18, isSelected: masouliat.value == 2 },
        { name: "سطح چهار", score: 24, isSelected: masouliat.value == 3 },
        { name: "سطح پنج", score: 30, isSelected: masouliat.value == 4 },
      ]

      setData(masouliatData)

      const selectedItem = masouliatData.find((i) => i.isSelected)?.score
      setForms(selectedItem)
      setGreadingScore((prev) => ({ ...prev, "forms": selectedItem }))
    }
  }, [reload])


  return (
    <div>
      <Row type={1}>
        <Column>سطح 1</Column>
        <Column>سطح 2</Column>
        <Column>سطح 3</Column>
        <Column>سطح 4</Column>
        <Column>سطح 5</Column>
      </Row>
      <Row type={2}>
        <Column paddingY={30}>
          تکمیل فرم های ساده و
          آمار
        </Column>
        <Column paddingY={30}>
          تنظیم فرم‌های مشکل و
          پیچیده و تشخیص نوع
          وقایع
        </Column>
        <Column paddingY={30}>
          بررسی فرم های
          مشکل و پیچیده و
          تهیه گزارش‌های نسبتا
          مهم
        </Column>
        <Column paddingY={30}>
          جمع آوری، مقایسه،
          محاسبه و تجزیه و
          تحلیل فرم‌ها و
          گزارشات و دسترسی
          به اطلاعات محرمانه
        </Column>
        <Column paddingY={30}>
          بررسی و تجزیه و تحلیل
          فرم‌ها، تهیه و تنظیم
          گزارش‌های تحلیلی مهم
          حقوقی، اقتصادی، مالی
          ،تولیدی، فنی و اداری
          که منجر به تدوین خط
          و مشی کلان می شود.
        </Column>
      </Row>
      <Row>
        <Column isActive={forms == 6}>6</Column>
        <Column isActive={forms == 12}>12</Column>
        <Column isActive={forms == 18}>18</Column>
        <Column isActive={forms == 24}>24</Column>
        <Column isActive={forms == 30}>30</Column>
      </Row>
    </div>
  );
};

export default Table7;
